module.exports = __webpack_public_path__ + "img/482.f631d2fa.png";